/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import { accessAPI, Boton } from "../../shared";
import {
  usePantallaActual,
  avisarDestacadosActualizados,
  EVENTO_DESTACADOS_ACTUALIZADOS,
  ANCHO_LATERAL,
  MEDIA_MOBILE
} from "./ContextoAsistente";

// Estrella fija junto al botón del asistente: destaca o quita de destacados la
// entidad que está en pantalla. Usa el mismo contexto que el asistente, así
// que aparece sola en toda pantalla que informa su entidad. Con el panel del
// asistente abierto se corre a su izquierda (en mobile el panel tapa todo y
// la estrella se oculta).
export default function BotonDestacar({ toast, lateralAbierto }) {
  const pantalla = usePantallaActual();
  const [destacadoId, setDestacadoId] = useState(null);
  const [cargando, setCargando] = useState(false);

  const tipo = pantalla?.tipo;
  const recursoId = pantalla?.id;

  useEffect(() => {
    setDestacadoId(null);
    if (!tipo || !recursoId) return;
    let vigente = true;
    const consultar = () =>
      accessAPI(
        "GET",
        `admin/misdestacados/estado?tipo=${tipo}&recursoId=${recursoId}`,
        null,
        (respuesta) => vigente && setDestacadoId(respuesta.destacadoId),
        () => {}
      );
    consultar();
    // El asistente puede destacar o quitar esta misma entidad desde el chat
    window.addEventListener(EVENTO_DESTACADOS_ACTUALIZADOS, consultar);
    // Si se navega antes de que responda, la respuesta vieja se ignora
    return () => {
      vigente = false;
      window.removeEventListener(EVENTO_DESTACADOS_ACTUALIZADOS, consultar);
    };
  }, [tipo, recursoId]);

  if (!tipo || !recursoId) return null;

  function mostrarError(error, texto) {
    toast?.current?.show({
      severity: "error",
      summary: "Error",
      detail: error?.[0]?.msg || texto,
      sticky: true
    });
  }

  function alternar() {
    setCargando(true);
    if (destacadoId) {
      accessAPI(
        "DELETE",
        `admin/misdestacados/${destacadoId}`,
        null,
        () => {
          setDestacadoId(null);
          setCargando(false);
          avisarDestacadosActualizados();
        },
        (error) => {
          setCargando(false);
          mostrarError(error, "No se pudo quitar de destacados.");
        }
      );
    } else {
      accessAPI(
        "POST",
        "admin/misdestacados",
        { tipo, recursoId },
        (respuesta) => {
          setDestacadoId(respuesta.destacadoId);
          setCargando(false);
          avisarDestacadosActualizados();
        },
        (error) => {
          setCargando(false);
          mostrarError(error, "No se pudo destacar.");
        }
      );
    }
  }

  return (
    <div
      css={{
        position: "fixed",
        right: lateralAbierto ? `${ANCHO_LATERAL + 20}px` : "84px",
        // Por encima de la botonera inferior de mobile (NavLateral)
        bottom: "calc(24px + var(--alto-barra-inferior, 0px))",
        zIndex: 1001,
        ...(lateralAbierto && { [MEDIA_MOBILE]: { display: "none" } }),
        "& .p-button": {
          width: "2.8rem",
          height: "2.8rem",
          padding: 0,
          justifyContent: "center",
          borderRadius: "50%",
          fontSize: "1.2rem",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)"
        },
        "& .pi-star-fill": { color: "var(--amarillo, #f5b800)" }
      }}
    >
      <Boton blanco disabled={cargando} callback={alternar}>
        <i className={destacadoId ? "pi pi-star-fill" : "pi pi-star"}></i>
      </Boton>
    </div>
  );
}
